(ns machtfit.navigation
  (:require [re-frame.core :as rf]))

(rf/reg-sub ::csrf-token
  (fn [db _]
    (get db :csrf-token)))

(rf/reg-sub ::urls
  (fn [db _]
    (get db :urls)))

(rf/reg-sub ::url
  :<- [::urls]

  (fn [urls [_ url-key]]
    (get urls url-key)))

